import React, { useEffect } from "react";
import "./Counter.css";
import { getcount } from "../../../features/home/homeSlice";
import { useDispatch, useSelector } from "react-redux";
import CountUp from "react-countup";

const Counter = () => {
  const data = [
    {
      count: "2K+",
      label: "Dedicated Employees",
      img: "/assets/images/home/counter/img1.png",
    },
    {
      count: "30+",
      label: "Dealers & Distributers",
      img: "/assets/images/home/counter/img2.png",
    },
    {
      count: "50+",
      label: "Monthly Manufacturing Capacity",
      img: "/assets/images/home/counter/img3.png",
    },
    {
      count: "15+",
      label: "Countries We Serve",
      img: "/assets/images/home/counter/img4.png",
    },
  ];

  const count = useSelector((state) => state?.home?.count);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getcount());
  }, []);

  // console.log(count,"2222222222222222222222")

  return (
    <section className="Counter">
      <div className="container">
        <div className="row">
          {count?.map((item) => {
            return (
              <div className="col-lg-3 col-sm-6 mb-3">
                <div className="counter_card">
                  <div className="right_div">
                    <img
                      src={process.env.REACT_APP_IMG_URL + item?.image}
                      className="img_inner"
                    />
                  </div>
                  <div className="text_holder">
                    <p className="count_text">
                      <CountUp
                        end={parseInt(item?.count)}
                        duration={2}
                        suffix={item?.count?.replace(/[0-9]/g, "")}
                      />
                    </p>
                    <p className="label_text">{item?.name}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Counter;
